const VIEW_MODES = {
    calendar: 0,
    rows: 1,
    grid: 2
};
/*
let defaultViewMode = VIEW_MODES.calendar;

if (!!localStorage['resevationViewMode']) {
    try {
        defaultViewMode = JSON.parse(localStorage['resevationViewMode']);
    } catch(e) {}
}
*/
export default {
    namespaced: true,
    state: {
        selectedViewMode: VIEW_MODES.calendar,
        timeTable: [],
        baseTimeTable: [],
        activeReservation: null,
        editReservation: null,
        availableAdditionalResources: [],
        additionalResourceQuantity: {}
    },
    getters: {
        selectedViewMode: (state) => state.selectedViewMode,
        VIEW_MODES: (state) => VIEW_MODES,
        timeTable: (state) => state.timeTable,
        baseTimeTable: (state) => state.baseTimeTable,
        reviewBlock: (state, getters, rootState, rootGetters) => (data) => {
            const { index, table } = data;
            const block = table.timeBlocks[index];
            const TIMEBLOCK_TYPE = rootGetters['reservations/TIMEBLOCK_TYPE'];
        
            let disallowedTypes = [
                TIMEBLOCK_TYPE.disabled, 
                TIMEBLOCK_TYPE.reservation, 
                TIMEBLOCK_TYPE.startTooClose, 
                TIMEBLOCK_TYPE.endTooClose,
                TIMEBLOCK_TYPE.reservationFull,
                TIMEBLOCK_TYPE.reservationInCart,
                TIMEBLOCK_TYPE.disallowedWithinTime,
                TIMEBLOCK_TYPE.disabledByRule,
                TIMEBLOCK_TYPE.startDisabled,
                TIMEBLOCK_TYPE.resellableReservation,
                TIMEBLOCK_TYPE.noDurationFits,
            ];

            if (rootGetters['common/adminMode']) {
                disallowedTypes = [
                    TIMEBLOCK_TYPE.disabled,
                    TIMEBLOCK_TYPE.reservation,
                    TIMEBLOCK_TYPE.reservationFull,
                    TIMEBLOCK_TYPE.reservationInCart,
                    TIMEBLOCK_TYPE.disabledByRule,
                    TIMEBLOCK_TYPE.resellableReservation,
                    TIMEBLOCK_TYPE.noDurationFits,
                ];
            }

            if (disallowedTypes.indexOf(block.type) > -1) {
                return false;
            }

            if (!rootGetters['common/adminMode'] && block.past) {
                return false;
            }

            return true;
        },
        availableBlocks: (state) => state.activeReservation.availableBlocks.length,
        selectedBlockIndex: (state) => state.activeReservation.selectedIndex,
        activeReservation: (state) => state.activeReservation || {
            placeholder: true,
            reservations: [],
            recurringDates: [],
            start: moment(),
            end: moment()
        },
        editReservation: (state) => state.editReservation || { block: {}, reservation: {}, timestamp: 0 },
        availableAdditionalResources: (state) => state.availableAdditionalResources,
        additionalResourceQuantity: (state) => state.additionalResourceQuantity,
        selectedAdditionalResources: (state) => {
            return state.availableAdditionalResources
                .map((resource) => {
                    resource.orderQuantity = state.additionalResourceQuantity[resource.resourceId] || 0;
                    return resource;
                })
                .filter(
                    (resource) => resource.orderQuantity > 0 && !!resource.productPrice
                )
        },
    },
    mutations: {
        setViewMode(state, mode) {
            if (typeof mode === 'string') {
                if (typeof VIEW_MODES[mode] === 'number') {
                    state.selectedViewMode = VIEW_MODES[mode];
                }
            } else {
                state.selectedViewMode = mode;
            }
        },
        setActiveReservation(state, reservation) {
            state.activeReservation = reservation;
            state.activeReservation.recurringDates = [];
        },
        setEditReservation(state, { block, reservation }) {
            state.editReservation = {
                block,
                reservation,
                timestamp: Date.now(),
            };
        },
        adjustAdditionalResourceQuantity(state, { add, row, force = false }) {
            if (add) {
                if (state.additionalResourceQuantity[row.resourceId] < row.maxQuantity 
                        && state.additionalResourceQuantity[row.resourceId] < row.availableQuantity) {
                    state.additionalResourceQuantity[row.resourceId] += 1;
                }
            } else {
                if (state.additionalResourceQuantity[row.resourceId] > 0 
                        && (state.additionalResourceQuantity[row.resourceId] > row.minQuantity || force)) {
                    state.additionalResourceQuantity[row.resourceId] -= 1;
                }
            }
        },
        setAdditionalResourceQuantity(state, { amount, row, force = false }) {
            const max = amount <= row.maxQuantity;
            const available = amount <= row.availableQuantity;
            const min = amount >= row.minQuantity;

            if ((max && available && min) || force) {
                state.additionalResourceQuantity[row.resourceId] = amount;
            }
        },
    },
    actions: {
        setEditReservation({ state, commit, rootGetters }, { block, reservation, cacheActiveReservation }) {
            if (!cacheActiveReservation) {
                state.activeReservation = null;
            }
            commit('setEditReservation', { block, reservation })
            commit('common/setModal', 'editreservation', { root: true })
            
            return Promise.resolve();
        },
        initTimeTables({ state }, data) {
            const { timeTable, baseTimeTable } = data;
            
            if (typeof timeTable !== 'undefined') {
                state.timeTable = data.timeTable;
            }
            
            if (typeof baseTimeTable !== 'undefined') {
                state.baseTimeTable = data.baseTimeTable;
            }
            //console.log('initTimeTables',state.timeTable)
            return Promise.resolve();
        },
        updateAvailableAdditionalResources({ state, rootGetters }, firstLoad = false) {
            const EcomService = rootGetters['ecom/EcomService'];
            const additionalResources = rootGetters['reservations/additionalResources'];
            const { groupResourcesAsProducts } = rootGetters['reservations/settings'];
            
            return EcomService.getResourceReservations(
                additionalResources.map(row => row.resourceId),
                state.activeReservation.start.format('YYYY-MM-DD HH:mm'),
                state.activeReservation.end.format('YYYY-MM-DD HH:mm')
            )
            .then((response) => {
                const data = response.data;

                if (data.success) {
                    state.availableAdditionalResources = additionalResources.map(resource => {
                        const reservations = data.resources[resource.resourceId];

                        resource.reservedQuantity = !!reservations ? reservations.quantity : 0;
                        resource.availableQuantity = resource.quantity - resource.reservedQuantity;

                        if (firstLoad) {
                            let setDefaultQuantity = true;
                            
                            if (!!groupResourcesAsProducts) {
                                setDefaultQuantity = false;
                            }

                            if (setDefaultQuantity) {
                                if (resource.minQuantity < resource.availableQuantity) {
                                    resource.orderQuantity = resource.minQuantity;
                                } else {
                                    resource.orderQuantity = resource.availableQuantity;
                                }
                            } else {
                                resource.orderQuantity = 0;
                            }
                        } else if (resource.orderQuantity > resource.availableQuantity) {
                            resource.orderQuantity = resource.availableQuantity;
                        }

                        return resource;
                    })
                    
                    if (firstLoad) {
                        state.additionalResourceQuantity = state.availableAdditionalResources.reduce((acc, curr) => {
                            acc[curr.resourceId] = curr.orderQuantity;
                            return acc;
                        }, {})
                    }
                }
            })
        },
    }
}